import { I18n } from '@calendly/i18n'
import { CheckboxInput } from '@calendly/ui/components/checkbox-input'

import { CheckboxFilterLayout } from './filter_layout'
import { OptionWrapper, StyledLabel } from './styles'

const COMPLETED = 'COMPLETED'

export const NotetakerRecap = ({ params, onChange, useColumnLayout = false }) => {
  const meetingIntelligenceStatus = params.meeting_intelligence_status
  const isChecked = meetingIntelligenceStatus === COMPLETED

  const onToggle = () => {
    onChange({
      ...params,
      meeting_intelligence_status: isChecked ? undefined : COMPLETED
    })
  }

  return (
    <CheckboxFilterLayout
      label={I18n.t('publisher.meetings.filter_modal.notetaker_recap.label')}
      useColumnLayout={useColumnLayout}
    >
      <OptionWrapper>
        <StyledLabel>
          <CheckboxInput
            checked={isChecked}
            onChange={onToggle}
          />
          {I18n.t('publisher.meetings.filter_modal.notetaker_recap.includes_recap')}
        </StyledLabel>
      </OptionWrapper>
    </CheckboxFilterLayout>
  )
}
